<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner">
      <v-card class="auth-card">
        <!-- logo -->
        <v-card-title class="d-flex align-center justify-center py-7">
          <div class="d-flex align-center">
            <v-img
              :src="appLogo"
              max-height="30px"
              max-width="30px"
              alt="logo"
              contain
              class="me-3 "
            ></v-img>

            <h2 class="text-2xl font-weight-semibold">
              {{ appName }}
            </h2>
          </div>
        </v-card-title>

        <!-- enrolment, still required -->
        <template v-if="!recoveryCodes.length">
          <v-card-text>
            <p class="text-2xl mb-2 font-weight-semibold text-center text--primary">
              تفعيل المصادقة الثنائية
            </p>
            <v-alert
              type="warning"
              text
              dense
              class="mb-0 mt-4"
            >
              تفعيل المصادقة الثنائية مطلوب للدخول الى النظام. اكمل الخطوات ادناه للمتابعة.
            </v-alert>
          </v-card-text>

          <v-card-text>
            <totp-enrollment
              block
              @enrolled="onEnrolled"
            />
          </v-card-text>
        </template>

        <!-- enrolled: hand over the recovery codes before letting them in -->
        <template v-else>
          <v-card-text>
            <p class="text-2xl mb-2 font-weight-semibold text-center text--primary">
              رموز الاسترداد
            </p>
            <v-alert
              type="info"
              text
              dense
            >
              احفظ هذه الرموز في مكان آمن. تظهر مرة واحدة فقط، ويستخدم كل رمز لمرة واحدة عند فقدان تطبيق المصادقة.
            </v-alert>
            <div class="recovery-codes">
              <code
                v-for="rc in recoveryCodes"
                :key="rc"
                class="d-block py-1"
              >{{ rc }}</code>
            </div>
          </v-card-text>

          <v-card-text>
            <v-btn
              text
              small
              class="mb-3"
              @click="copyRecoveryCodes"
            >
              <v-icon
                small
                class="me-1"
              >
                {{ icons.mdiContentCopy }}
              </v-icon>
              نسخ
            </v-btn>
            <v-btn
              block
              color="primary"
              :loading="entering"
              :disabled="entering"
              @click="enterSystem"
            >
              حفظت الرموز، متابعة الى النظام
            </v-btn>
          </v-card-text>
        </template>

        <!-- footer -->
        <v-card-text class="d-flex align-center mt-2">
          <v-divider></v-divider>
          <span class="mx-5">  مركز الكفيل لتقنية المعلومات </span>
          <v-divider></v-divider>
        </v-card-text>
      </v-card>
    </div>

    <!-- background triangle shape  -->
    <img
      class="auth-mask-bg"
      height="173"
      :src="require(`@/assets/images/misc/mask-${$vuetify.theme.dark ? 'dark':'light'}.png`)"
      alt="auth-mask-bg"
    />
  </div>
</template>

<script>
import { mdiContentCopy } from '@mdi/js'
import themeConfig from '@themeConfig'
import TotpEnrollment from '@/components/TotpEnrollment.vue'
import toast from '@/store/toast'
// eslint-disable-next-line import/no-cycle
import auth from '@/store/auth'
// eslint-disable-next-line import/no-cycle
import router from '@/router'

export default {
  name: 'TotpSetup',
  components: { TotpEnrollment },
  data: () => ({
    recoveryCodes: [],
    entering: false,
    appName: themeConfig.app.name,
    appLogo: themeConfig.app.logo,
    icons: { mdiContentCopy },
  }),
  methods: {
    onEnrolled(payload) {
      this.recoveryCodes = payload.recovery_codes
      toast.dispatch('success', 'تم تفعيل المصادقة الثنائية بنجاح.')
    },
    async enterSystem() {
      this.entering = true
      try {
        // refresh the stored user so must_setup is cleared before the guard runs
        await auth.dispatch('getUser')
        await router.push('/home')
      } finally {
        this.entering = false
      }
    },
    async copyRecoveryCodes() {
      try {
        await navigator.clipboard.writeText(this.recoveryCodes.join('\n'))
        await toast.dispatch('success', 'تم نسخ رموز الاسترداد.')
      } catch (error) {
        await toast.dispatch('error', 'لم يتم النسخ، يرجى النسخ يدويا.')
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/pages/auth.scss';
</style>

<style scoped>
.recovery-codes code {
  font-size: 0.95rem;
  letter-spacing: 1px;
}
</style>
